import { SVGProps } from 'react';
import literals from '~theme/literals';

function ShieldStar(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-label="icon de alerta"
      width={18}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M16.398 3.143A18.202 18.202 0 0 0 9 1.625c-2.545-.017-5.065.5-7.397 1.518a1.25 1.25 0 0 0-.728 1.143v6.268a9.983 9.983 0 0 0 6.4 9.318 5.15 5.15 0 0 0 1.725.5 5.134 5.134 0 0 0 1.725-.5 9.982 9.982 0 0 0 6.4-9.318V4.286a1.25 1.25 0 0 0-.727-1.143Z"
        stroke={literals.surface.primary}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m9.389 7.903.833 1.798h1.625a.398.398 0 0 1 .281.695l-1.41.983.782 1.795a.426.426 0 0 1-.606.532l-1.888-1.063-1.889 1.063a.426.426 0 0 1-.606-.532l.781-1.795-1.41-.983a.398.398 0 0 1 .28-.695h1.624l.834-1.798a.43.43 0 0 1 .769 0Z"
        fill={literals.surface.primary}
        stroke={literals.surface.primary}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ShieldStar.defaultProps = {
  role: 'graphics-document',
};

export default ShieldStar;
